var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 5.16666H2.66671C1.93033 5.16666 1.33337 5.76361 1.33337 6.49999V13.1667C1.33337 13.903 1.93033 14.5 2.66671 14.5H13.3334C14.0698 14.5 14.6667 13.903 14.6667 13.1667V6.49999C14.6667 5.76361 14.0698 5.16666 13.3334 5.16666Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 14.5V3.83333C10.6667 3.47971 10.5262 3.14057 10.2762 2.89052C10.0261 2.64048 9.687 2.5 9.33337 2.5H6.66671C6.31309 2.5 5.97395 2.64048 5.7239 2.89052C5.47385 3.14057 5.33337 3.47971 5.33337 3.83333V14.5",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.c539f272afec15ac75cd2e669c59ea4e.svg";
export { ForwardRef as ReactComponent };